import { Calendar, DateLocalizer } from 'react-big-calendar';
import noop from 'lodash/noop';
import { injectIntl } from 'react-intl';
import { compose, withProps } from 'react-recompose';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './overrides.css';
import formatKeys from './formatKeys';

const timeRangeOptions = { hour: 'numeric', minute: 'numeric', hour12: true };
const keys = formatKeys();

function createLocalizer(formatDate, formatTime) {
  return new DateLocalizer({
    firstOfWeek(culture) {
      return 0;
    },

    formats: {
      [keys.dayRangeHeaderFormat]: ({ start, end }) => {
        if (start.getMonth() === end.getMonth()) {
          return `${formatDate(start, { month: 'long', day: '2-digit' })} - ${formatDate(end, { day: '2-digit' })}`;
        } else {
          return `${formatDate(start, { month: 'long', day: '2-digit' })} - ${formatDate(end, { month: 'long', day: '2-digit' })}`;
        }
      },
      [keys.eventTimeRangeFormat]: noop,
      [keys.eventTimeRangeStartFormat]: noop,
      [keys.eventTimeRangeEndFormat]: noop,
      [keys.agendaHeaderFormat]: ({ start, end }) => (
        `${formatDate(start)} - ${formatDate(end)}`
      ),
      [keys.agendaTimeRangeFormat]: ({ start, end }) => (
        `${formatTime(start, timeRangeOptions)} - ${formatTime(end, timeRangeOptions)}`
      ),
    },

    format(value, format, culture) {
      switch (format) {
        case keys.dateFormat:
          return formatDate(value, { day: '2-digit' });
        case keys.dayFormat:
          return `${formatDate(value, { day: '2-digit' })} ${formatDate(value, { weekday: 'short' })}`;
        case keys.weekdayFormat:
          return formatDate(value, { weekday: 'long' });
        case keys.agendaTimeFormat:
        case keys.timeGutterFormat:
          return formatTime(value, { hour: 'numeric', minute: 'numeric', hour12: true });
        case keys.monthHeaderFormat:
          return formatDate(value, { month: 'long', year: 'numeric' });
        case keys.dayHeaderFormat:
          return formatDate(value, { weekday: 'long', month: 'short', day: '2-digit' });
        case keys.agendaDateFormat:
          return formatDate(value, { weekday: 'short', month: 'short', day: '2-digit' });
      }
      /* istanbul ignore next */
      throw new Error(`Unknown format encountered: ${format}`);
    },
  });
}

export default compose(
  injectIntl,
  withProps(({ intl }) => ({ localizer: createLocalizer(intl.formatDate, intl.formatTime) })),
)(Calendar);
